import React from 'react';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import useEcoASocial from '../../hooks/useEcoASocial';
import './EcoAllianceJoin.scss';
import useEcoAllianceReels from '../../hooks/useEcoAllianceReels';
import ReelVideo from '../../Common/ReelVideo/ReelVideo';
import downloadEcoAllianceQrCertification from "../../../utils/downloadEcoAllianceQrCertification";

const EcoAllianceJoin = () => {
  
  const ecoASocialList = useEcoASocial();

  const { posts : {edges : ecoASocialListTemp}} = ecoASocialList;
  const ecoASocial = ecoASocialListTemp.filter(item => item.node.feature_image);

  const ecoAllianceReelsList = useEcoAllianceReels();
  const { allContentfulEcoAllianceVideoReel : {edges : ecoAllianceReels}} = ecoAllianceReelsList;

  const concatArray = (...arrays) => {
    const conArray = [];
    for (let i = 0; i < Math.max(...arrays.map(a => a.length)); i++) {
      arrays.forEach((array) => {
        if (array[i] !== undefined) conArray.push(array[i]);
      });
    }
    return conArray;
  };

  return (
    <div className="noissue__eco-alliance__join">
      <div className="heading" role="presentation" onClick={downloadEcoAllianceQrCertification}>
        <u>Join our community </u> and start making a difference today.
      </div>
      <div className="eco-alliance-join-reel">
        {
          concatArray(ecoAllianceReels, ecoASocial).map((item, idx) => {
            return (
              item.node.videoTitle ? 
                <ReelVideo item={item} key={idx} />
              :
              <div key={idx} className="eco-alliance-join-reel-item" role="presentation">
                <CommunityImg src={item.node.feature_image} alt="eco reel" />
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default EcoAllianceJoin;
